// extracted by mini-css-extract-plugin
module.exports = {"container":"_1Y24HLygxHCsOu2ZWPdPz9","closeIcon":"_3njvopJeoAcQ1yPiNapsPV"};